import type { PlanEducationIconId } from './planEducationIcons'

/** Ideal portfolio / Ideal SIPs timer shell rows (lumpsum + SIP share the same copy). */
export const IDEAL_FEATURE_ROWS = [
  {
    iconId: 'investWithConfidence' as const satisfies PlanEducationIconId,
    title: 'Invest with confidence',
    caption: 'using your ideal portfolio as a guide'
  },
  {
    iconId: 'portfolioClarity' as const satisfies PlanEducationIconId,
    title: 'Complete portfolio clarity',
    caption: 'so you can take more informed decisions'
  }
] as const
